import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core'
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { MatSelectModule } from '@angular/material/select'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { PaymentMethodsService } from '../../../../core/services/payment/payment-methods/payment-methods.service'
import { MatDatepicker, MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { ServiceOrderService } from '../../../../core/services/service/service-order/service-order.service'
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from "@angular/material/progress-spinner";




@Component({
  selector: 'service-order-edit',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatStepperModule,
    MatDatepicker,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinner
  ],
  templateUrl: './service-order-edit.component.html',
  styleUrl: './service-order-edit.component.scss',
  providers: [
    ServiceOrderService,
    PaymentMethodsService
  ],
  standalone: true,
})
export class ServiceOrderEdit implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceOrderService: ServiceOrderService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ServiceOrderEdit>,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) { }

  @Input() itemOs: any
  @Output() responseCreate = new EventEmitter()
  @Output() response = new EventEmitter()
  @Output() valid = new EventEmitter()
  @Output() itemPropostaId = new EventEmitter();
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined
  @Input() idItemContract: number = -1
  @Input() idContractClient: number = -1



  passengersValid = true;
  itineraryValid = true;
  scheduleValid = false;
  formLegalEntity: FormGroup = new FormGroup({})
  page: number = 1
  rows: number = 10
  numberRows: number = 0
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  item: any = { user: false, data: [] }
  maxDate!: Date
  formCheck: any
  edit: boolean = false
  create: boolean = false
  itemsList: any[] = []






  ListItemsProposal: any[] = []
  vehicleTypeList: any[] = []
  listTypeDriver: any[] = []
  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}
  editIndex: number | null = null;
  editAgendaItem: any = null;



  ngOnInit(): void {
    this.createForm()
    this.fillForm()
    this.checkEditonOrCreate()
    console.log('Dados que tenho no service order', this.itemOs)

  }


  checkEditonOrCreate() {
    const dateInitial = this.formLegalEntity.get('dateInitial')?.value
    const dateFinal = this.formLegalEntity.get('dateFinal')?.value
    const endHours = this.formLegalEntity.get('timeFinal')?.value
    const initalHours = this.formLegalEntity.get('timeStart')?.value

    if (dateInitial || dateFinal || initalHours || endHours) {
      this.edit = true
    } else {
      this.edit = false
    }
  }





  formatHour(time: any): string {
    if (!time) return '';
    return time.slice(0, 5)
  }



  fillForm() {
    if (this.itemOs && this.itemOs.dataInicio) {
      const [dia, mes, ano] = this.itemOs.dataInicio.split('/');
      const dataInicioDate = new Date(+ano, +mes - 1, +dia);
      this.formLegalEntity.patchValue({ dateInitial: dataInicioDate });
    }
    if (this.itemOs && this.itemOs.dataFinal) {
      const [dia, mes, ano] = this.itemOs.dataFinal.split('/');
      const dataFimDate = new Date(+ano, +mes - 1, +dia);
      this.formLegalEntity.patchValue({ dateFinal: dataFimDate });
    }

    if (this.itemOs.horaInicio && this.itemOs.horaFinal) {
      this.valid.emit(true)
    }

    this.formLegalEntity.patchValue({
      os: this.itemOs.codigoOs ?? '',
      nomeEvento: this.itemOs.nomeEvento ?? '',
      status: this.itemOs.descricaoStatusOs ?? '',
      cliente: this.itemOs.nomeCliente ?? '',
      timeFinal: this.formatHour(this.itemOs.horaFinal) ?? '',
      timeStart: this.formatHour(this.itemOs.horaInicio) ?? '',
      subClient: this.itemOs.nomeSubCliente ?? '',
      codigoTG: this.itemOs.codigoTg ?? '',
      servico: this.itemOs.servico ?? '',
      observation: this.itemOs.observacao ?? '',
      consultorCliente: this.itemOs.nomeConsultor ?? '',
      consultorComercial: this.itemOs.consultorComercial ?? '',
      valueTariff: this.itemOs.valorTarifario ?? '',
      valueProposal: this.itemOs.valorProposta ?? '',
      qtdPassageiros: this.itemOs.quantidadePassageiros ?? '',
      valueBuy: this.itemOs.valorCompra ?? '',
      tipoServico: this.itemOs.tipoServico ?? '',
      vehicle: this.itemOs.nomeTipoVeiculo ?? '',
      typeDriver: this.itemOs.nomeTipoMotorista ?? '',
    });

    if (this.itemOs.dataFinal && this.itemOs.dataInicio) {
      this.edit = true
      this.create = false
      console.log('edit:', this.edit)
    } else {
      this.edit = false
      this.create = true
      console.log('create:', this.create)
    }

    if (this.itemOs.subClienteId == null) {
      this.formLegalEntity.get('subCliente')?.disable();
    }

    if (!this.itemOs.consultorComercial) {
      this.formLegalEntity.get('consultorComercial')?.disable();
      this.formLegalEntity.get('subCliente')?.disable();
    }

  }





  treatResponse(response: any) {
    let list = []
    if (response.data) {


      for (let itens in response.data) {
        list.push(itens)
      }

    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }



  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      codigoTG: [''],
      os: [''],
      status: [''],
      cliente: [''],
      subCliente: [''],
      consultorCliente: [''],
      consultorComercial: [''],
      nomeEvento: [''],
      tipoServico: [''],
      servico: [''],
      fornecedor: [''],
      typeService: [''],
      vehicle: [''],
      tipoMotorista: [''],
      motorista: [''],
      qtdPassageiros: [''],
      tipoVeiculo: [''],
      veiculo: [''],
      typeDriver: [''],
      valueBuy: ['', [Validators.required]],
      valueProposal: ['', [Validators.required]],
      valueTariff: ['', [Validators.required]],
      timeStart: ['', [Validators.required]],
      timeFinal: ['', [Validators.required]],
      observation: [''],
      dateInitial: ['', [Validators.required]],
      dateFinal: ['', [Validators.required]],

    }, { validators: [this.validationHours, this.validationDates] })


  }

  validationHours(group: AbstractControl) {
    const start = group.get('timeStart')?.value;
    const end = group.get('timeFinal')?.value;

    if (start && end && start > end) {
      return { horarioInvalido: true };
    }
    return null;
  }

  validationDates(group: AbstractControl) {
    const start = group.get('dateInitial')?.value;
    const end = group.get('dateFinal')?.value;

    if (start && end && new Date(start) > new Date(end)) {
      return { dataInvalida: true };
    }
    return null;
  }

  formatHours(hours: any) {
    // const date = new Date();
    // date.setHours(hours);

    return `${hours}:00`;
  }


  pushdates() {
    this.loading = true





  }


  formatDate(date: string): string {
    const dateObject = new Date(date);
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    return `${dateObject.getDate()}/${month}/${dateObject.getFullYear()}`;
  }
}
